import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import showPlaceholderPageData from "./showPlaceholderPagesData";

export default function Help() {
    const { t } = useTranslation('placeholdersPages')
    const helpData = t("help.array", { returnObjects: true })

    return (
        <Container>
            <Row className="text-start">
                <Col xs={12}>
                    <Row>
                        <Col xs={12} xl={12}>
                            <Row>
                                <Col xs={12}>
                                    <h1 className="text-center mt-lg-5 fw-bold">
                                        {t('help.title')}
                                    </h1>
                                </Col>
                                <Col xs={12}>
                                    <h2 className="ps-5 border-bottom border-warning mb-5"></h2>
                                </Col>
                                <Col xs={12}>
                                    <Row>
                                        <Col xs={12}>
                                            <Row className="flex-row-reverse">
                                                <Col xs={12} md={6}>
                                                    <p className="p-5 fw-medium rounded-4 bg-warning-subtle  border-start border-5 border-warning ">
                                                        {t('help.header')}
                                                    </p>
                                                </Col>
                                            </Row>
                                            {showPlaceholderPageData(helpData)}
                                            <p className="text-center  p-5 rounded-4 fst-italic fw-medium w-75 mx-auto">
                                                {t('help.summary')}
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}